import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';

export const PhotoProcessing: React.FC = () => {
	return (
		<Box aria-hidden="true" sx={{ overflow: 'hidden' }}>
			<Flex
				sx={{
					aspectRatio: '16 / 9',
					height: '100%',
					alignItems: 'center',
					justifyContent: 'center',
					overflow: 'hidden',
				}}
			>
				<Loader size="xs" />
			</Flex>
		</Box>
	);
};
